import * as constants from '../constants'

export const setChargePoints = (chargePoints) => {
  return {
    type: constants.SET_CHARGEPOINTS,
    chargePoints,
  }
}

export const setAllOriginChargePoints = (chargePoints) => {
  return {
    type: constants.SET_ALL_ORIGIN_CHARGEPOINTS,
    chargePoints,
  }
}

export const setPlugShareOriginChargePoints = (chargePoints) => {
  return {
    type: constants.SET_PLUG_SHARE_CHARGEPOINTS,
    chargePoints,
  }
}

export const setChargePointConnector = (chargeBoxId, connectorId, connector) => {
  return {
    type: constants.SET_CHARGEPOINT_CONNECTOR,
    chargeBoxId,
    connectorId,
    connector,
  }
}

export const setConnectorType = (connectorType, chargeBoxPk, connectorId) => {
  return {
    type: constants.SET_CONNECTOR_TYPE,
    connectorType,
    chargeBoxPk,
    connectorId,
  }
}

export const setChargePoint = (data, chargeBoxPk) => {
  return {
    type: constants.SET_CHARGE_POINT,
    data,
    chargeBoxPk,
  }
}
